export const defaultNavbarContent = {
  primaryCTA: "Book your visit",
  primaryCTAUrl: "/booking",
  secondaryCTA: "Contact Us",
  secondaryCTAUrl: "/contact",
  logoUrl:
    "https://joyprod-imageassets.s3.us-east-2.amazonaws.com/shared/logo-example.svg",
};
